import { EngineUtils } from '../services/EngineUtils.js';

export type AggregateFunction<P> = (prev: P, next: P) => P;

export class ObjectHashSetWithPayload<P> {
  referenceSet = new Map<string, [any, P]>();

  constructor(private readonly aggregateFunction: AggregateFunction<P>) {
  }

  add(value: unknown, payload?: P) {
    let payloadToSave = payload;
    const hash = EngineUtils.hash(value);
    if (this.referenceSet.has(hash)) {
      const [, prevPayload] = this.referenceSet.get(hash)!;
      payloadToSave = this.aggregateFunction(prevPayload, payload);
    }
    this.referenceSet.set(hash, [value, payloadToSave]);
  }

  has(value: unknown): boolean {
    return this.referenceSet.has(EngineUtils.hash(value));
  }

  delete(value: unknown) {
    this.referenceSet.delete(EngineUtils.hash(value));
  }

  toArray(): [any, P][] {
    return Array.from(this.referenceSet.values());
  }
}

export function keepLastAggregateFunction<T>(prev: T, next: T) {
  return next;
}

export function keepFirstAggregateFunction<T>(prev: T, next: T) {
  return prev;
}
